import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "type", "label", "icon", "spanElProps"];
import { clsx } from 'clsx';
import { getTagIcon, getTagLabel } from "./utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TextTag = function TextTag(_ref) {
  var className = _ref.className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'freemium' : _ref$type,
    label = _ref.label,
    icon = _ref.icon,
    spanElProps = _ref.spanElProps,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var tagLabel = label || getTagLabel({
    type: type
  });
  var tagIcon = getTagIcon({
    type: type,
    icon: icon,
    label: label
  });
  return /*#__PURE__*/_jsxs("span", _objectSpread(_objectSpread(_objectSpread({}, spanElProps), otherProps), {}, {
    className: clsx('tw-inline-flex tw-gap-0.4 tw-items-center',
    // DISPLAY
    'tw-whitespace-nowrap', 'tw-font-caption tw-lowercase',
    // FONT
    'tw-py-0.4 tw-px-1.2 tw-rounded-[4rem]',
    // SPACING
    className !== null && className !== void 0 && className.includes('tw-text-') ? '' : 'tw-text-primary-light-400',
    // COLORS TEXT
    className !== null && className !== void 0 && className.includes('tw-bg-') ? '' : 'tw-bg-primary-light-100',
    // COLORS background
    className),
    children: [tagIcon && tagIcon({
      className: 'tw-h-1.6 tw-w-1.6'
    }), /*#__PURE__*/_jsx("span", {
      className: "first-letter:tw-uppercase",
      children: tagLabel
    })]
  }));
};
export default TextTag;